import Event from '../domain/Event.js';

let MYEFC_AUTH_COOKIE_NAME = 'myEfcCookieAuth';

class OpenIdLoginHandler {

  constructor(controller, requestBuilder, httpService, trackingService, cookieUtils, utils) {

    this.controller = controller;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;
    this.cookieUtils = cookieUtils;
    this.utils = utils

  }

  handleSubmit(token, provider) {

    this.controller.startActionInProgress();

    this.controller.setState({
      formInProgress: 'SOCIAL_SIGNIN',
      openIdProvider: provider
    });

    let authenticationRequest = this.requestBuilder.getAccessTokenWithOpenIdTokenRequest(token);

    return this.httpService.get(authenticationRequest)
      .then((response) => {

        switch (response.status) {
          case 200:
            process200Response.bind(this)(response);
            break;
          default:
            return process201Response.bind(this)(response);
        }

      });

  }

}

let process200Response = function (response) {

  let askForEmailForRegister = true;
  let showVerifiedEmailSentPage = false;

  response.data.next_options.forEach(function(option) {

    switch (option.next_action) {
      case 'COMPLETE_ACCOUNT_WITHOUT_EMAIL':
        askForEmailForRegister = false;
        break;
      case 'FOLLOW_VERIFICATION_EMAIL_INSTRUCTIONS':
        showVerifiedEmailSentPage = true;
        break;
    }

  });

  if (showVerifiedEmailSentPage) {

    this.controller.showVerifiedEmailSentPage();

  } else {

    this.controller.setState({
      requestToken: response.data.request_token,
      askForEmailForRegister: askForEmailForRegister
    });

    this.controller.showLinkAccountRegisterPage();

  }

};

let process201Response = function (response) {

  this.cookieUtils.set(MYEFC_AUTH_COOKIE_NAME, response.data.access_token, {domain: this.utils.getCookieDomain(), path: '/'});
  this.trackingService.submitEvent(Event.OPENID_LOGIN);
  this.controller.handleSuccess(response.data);

  return response;

};

export default OpenIdLoginHandler;



// WEBPACK FOOTER //
// ./src/library/handlers/OpenIdLoginHandler.js